//


function deepGetSet(obj, path, value) {
  if (arguments.length === 3) return deepSet.apply(null, arguments);
  return deepGet.apply(null, arguments);
}

function deepGet(obj, path) {
  const keys = Array.isArray(path) ? path : path.split('.');
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (!obj || !obj.hasOwnProperty(key)) {
      obj = undefined;
      break;
    }
    obj = obj[key];
  }
  return obj;
}

function deepSet(obj, path, value) {
  const keys = Array.isArray(path) ? path : path.split('.');
  let i = 0;
  for (; i < keys.length - 1; i++) {
    const key = keys[i];
    if (!obj.hasOwnProperty(key)) obj[key] = {};
    obj = obj[key];
  }
  obj[keys[i]] = value;
  return value;
}

export default deepGetSet;